import DashboardTableCard from './DashboardTableCard';

export default DashboardTableCard;
